import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { AiOutlineSend } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";

const ChatModal = ({ messages }) => {
  const messageRef = useRef(null);
  const user = useSelector((state) => state.cartDetail);

  useEffect(() => {
    messageRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="chat_modal_container">
      <div className="chat_modal">
        <div className="chatHeader">
          <div className="chat_name">Notification 🔔</div>
        </div>
        <div className="body_message">
          {messages.length > 0 &&
            messages.map((data, idx) => {
              return (
                <div className="message_detail" key={idx} ref={messageRef}>
                  <p className="the_message">
                    {data?.text}

                    {/* <span className="admin_typing">Admin is typing...</span> */}
                  </p>
                </div>
              );
            })}
        </div>
        <div className="typing_notif">
          {user?.notify === true && (
            <span className="admin_typing">Admin is typing...</span>
          )}
        </div>
        {/* <div className="input_message">
          <input
            type="text"
            className="message_input"
            value="Not Available"
            disabled={true}
          />
          <AiOutlineSend className="send-icon" />
        </div> */}
      </div>
    </div>
  );
};

export default ChatModal;
